export default __webpack_public_path__ + "static/media/contactsPink.ed39afa6.svg";